import { h } from 'preact';
import { useState } from 'preact/hooks';
import { useKitProduct } from './product-context';
import Icon from 'utils/icon';
import '../add-to-cart-button.css';

const KitAddToCartButton = ({ children }) => {
  const { kitProducts } = useKitProduct();
  if (!kitProducts) return null;

  const [quantity, setQuantity] = useState(1);
  const available = kitProducts.every(
    (product) => product.selectedVariant.available,
  );

  const handleAddToCart = () => {
    const variantIds = kitProducts.map((product) => product.selectedVariant.id);
    const payload = variantIds.map((id) => {
      return {
        id,
        quantity,
      };
    });

    document.dispatchEvent(
      new CustomEvent('cart:add', {
        detail: {
          payload,
        },
      }),
    );
  };

  return (
    <div className="flex items-center h-[50px]">
      <div className="flex items-center h-[50px] w-[95px] pl-[11px] border-1 border-text-1 rounded-tl-[6px] rounded-bl-[6px]">
        <button
          className="h-full cursor-pointer"
          onClick={() => {
            if (quantity > 1) setQuantity(quantity - 1);
          }}
        >
          <Icon id="minus" className="stroke-text-1" />
        </button>
        <input
          className="quantity-input text-center w-[40px] border-0 m-0 text-text-1 focus:!outline-none border-transparent focus:border-transparent focus:ring-0"
          type="number"
          id="quantity"
          name="quantity"
          min="1"
          value={quantity}
          onChange={(e) => setQuantity(e.target.value)}
        />
        <button
          className="h-full cursor-pointer"
          onClick={() => setQuantity(quantity + 1)}
        >
          <Icon id="plus" className="stroke-text-1" />
        </button>
      </div>
      <button
        id="atc-button"
        className={`${
          !available ? 'bg-gray-300 border-l-0' : 'bg-text-1'
        } grow self-stretch text-white border-1 border-text-1 rounded-tr-[6px] rounded-br-[6px] cursor-pointer`}
        onClick={() => handleAddToCart()}
        disabled={!available}
      >
        {available
          ? window.TMW.Strings.product.addToCart
          : window.TMW.Strings.product.unavailable}
      </button>
    </div>
  );
};

export default KitAddToCartButton;
